module.exports = __webpack_public_path__ + "static/media/play-patch.de294315.png";